import type { ParsedUrlQuery } from 'querystring';

import { SProductFilters } from '@/generated/graphql/types';
import { PlainQueryParams } from '@/productDiscovery/Listings/interfaces/algolia';

export const generateFilters = (
  queryParams: ParsedUrlQuery | PlainQueryParams,
): SProductFilters => {
  return {
    ...(queryParams.brand_names && {
      brandNames: (queryParams.brand_names as string).split('__'),
    }),
    ...(queryParams.mmf && {
      isMF: queryParams.mmf === '1',
    }),
    ...(queryParams.catId && {
      categoryIds: [queryParams.catId as string],
    }),
    ...(queryParams.rating && {
      minRating: parseInt((queryParams.rating as string).split('__')[0], 10),
    }),
    ...(queryParams['price[min]'] && {
      priceRange: {
        min: parseFloat(queryParams['price[min]'] as string),
        max: parseFloat(queryParams['price[max]'] as string),
      },
    }),
  };
};
